import {
  OmCol,
  OmDialog,
  OmPopover,
  OmRow,
  omMessage,
  omNotification,
  type OmMenuItem,
} from '@owma/kit'
import classNames from 'classnames'
import i18n from 'i18n'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'router'
import { confirmDelete, showFullScreenLoading, hideFullScreenLoading } from 'utils/ui'
import { getSearchParams } from 'utils'
import { setSearchParams } from 'appUtils'
import { toDavPath } from 'libs/dav/davPath'
import moment from 'moment'

import SearchPortal from 'pages/main/components/SearchPortal'
import CalendarDatePicker from 'pages/todo/components/DatePicker'
import { DatePickerType } from 'pages/todo/components/DatePicker/DatePickerType'

import AccountInfoView from './components/AccountInfoView'
import AgendaBox from './components/AgendaBox'
import CalendarMobile from './components/CalendarMobile'
import CalendarToolbar from './components/CalendarToolbar'
import DayBox from './components/DayBox'
import EventDetail from './components/EventDetail'
import EventEditor from './components/EventEditor'
import FolderEditor from './components/FolderEditor'
import FolderList from './components/FolderList'
import SubscriptionEditor from './components/SubscriptionEditor'
import type { SubscriptionEditorData } from './components/SubscriptionEditor'
import FolderShareInfo from './components/FolderShareInfo'
import InvitationList from './components/InvitationList'
import MonthBox from './components/MonthBox'
import TaskDrawer from './components/TaskDrawer'
import WeekBox from './components/WeekBox'

import TaskFolderList from './components/TaskFolderList'

import * as calendarService from './modules/CalendarService'
import {
  confirmAndDeleteEvent,
  getRecurrenceScopeOptions,
  isEventEditable,
} from './utils/EventActions'

import styles from './style.module.scss'
import * as dateUtils from './utils/DateUtils'

import openDrawer from 'assets/images/calendar/toolbar-open-pane.svg'
import optionSVG from 'assets/images/option-24.svg'
import calendarIcon from 'assets/images/calendar/icon-calendar-24.svg'

import { modalTodoDetails } from 'pages/todo/components/TodoDetails/modalHelpers'
import settingsObject from 'popups/Settings'

const mapStateToProps = ({ user, settings, appsettings }) => ({
  user,
  settings,
  appsettings,
  viewMode: appsettings.viewMode,
})

let isUnmounted = false

class CalendarDef extends React.Component<any, any> {
  state = {
    folders: [],
    isExpanded: true,
    focusedDate: calendarService.getCurrentDate(),
    browseDate: calendarService.getCurrentDate(),
    showEventEditor: false,
    editingEvent: null,
    showSidebar: this.props.viewMode !== 'tablet',
    showFolderEditor: false,
    editingFolder: null,
    notiCount: calendarService.getNotifications().length,
    showNotification: false,
    viewType: this.props.settings.localSettings.calendar.calendarViewType,
    selectedEvent: null,
    eventDetailPosition: null,
    searchedEvents: null,
    dropdownContent: null,
    dropdownTarget: null,
    showDropdown: false,
    showShareInfoModal: false,
    shareInfoInvitees: [],
    shareInfoLoading: false,
    shareInfoFolder: null,
    showSubscriptionEditor: false,
    editingSubscription: null as any,
    subscriptionSaving: false,
    isMobileView: this.props.appsettings.isMobileView,
    taskDrawerOpen: this.props.settings.localSettings.calendar.taskDrawerOpen,
    taskDrawerHeaderHeight: 81,
    onEditComplete: null as any,
    recurrenceEditMode: null as any,
    duplicateEvent: false,
    targetDates: null as any,
    forAllday: false,
    openSearchFilter: null as any,
  }

  searchRef: any = null
  searchInfo: any = null

  calendarNavigationRef: any = React.createRef()
  calendarRef: any = React.createRef()
  dayBoxRef: any = React.createRef()

  folderListener = () => {
    const calendars = calendarService.getCalendars() || []
    console.log('calendars: %o', calendars)
    this.setState({ folders: calendars })
  }

  notificationListener = () => {
    const notifications = calendarService.getNotifications() || []
    this.setState({ notiCount: notifications.length })
  }

  // React 컴포넌트 리렌더링
  instanceListener = () => {
    // 상세 팝오버가 열려 있는데 해당 instance 가 삭제/동기화로 사라졌으면 닫아 빈 팝오버 잔상을 막는다.
    // 단 sync 중간 상태에서는 instance 목록이 일시적으로 비므로, 동기화가 끝난 뒤에만 닫아 깜빡 닫힘을 방지한다.
    const { selectedEvent } = this.state
    if (
      selectedEvent &&
      !calendarService.isSyncing() &&
      !calendarService.getInstances().some((i) => i.id === selectedEvent.instanceId)
    ) {
      this.handleEventDetailClose()
    }

    if (this.isSearching()) {
      let changed = false
      const updatedEvents = this.state.searchedEvents.map((event) => {
        const instance = calendarService.getInstances().find((i) => i.serverId === event.serverId)
        if (instance && instance.etag !== event.etag) {
          changed = true
          return instance
        } else {
          return event
        }
      })
      if (changed) {
        this.setState({ searchedEvents: updatedEvents })
      }
    }
  }

  runFocusEvent = (instance, retry = false) => {
    const eventCell = document.getElementById(instance.id)
    if (eventCell) {
      eventCell.scrollIntoView({ behavior: 'instant', block: 'nearest' })
      this.showEventDetail({ instanceId: instance.id, date: instance.startDate }, eventCell)
      hideFullScreenLoading()
    } else {
      const overCountId = 'over-count-' + moment(instance.startDate).format('YYYY-MM-DD')
      const overCountCell = document.getElementById(overCountId)
      if (overCountCell) {
        overCountCell.click()

        const _runShowEventDetail = (count) => {
          if (count > 9) {
            hideFullScreenLoading()
            omMessage.error(i18n.t('meeting.error.eventNotFound'))
            return
          }
          const cellElement = document.getElementById(instance.id)
          if (cellElement) {
            this.showEventDetail({ instanceId: instance.id, date: instance.startDate }, cellElement)
            hideFullScreenLoading()
          } else {
            setTimeout(() => {
              if (isUnmounted) return
              _runShowEventDetail(count + 1)
            }, 100)
          }
        }

        setTimeout(() => {
          if (isUnmounted) return
          _runShowEventDetail(0)
        }, 100)
      } else {
        if (retry === false) {
          setTimeout(() => {
            if (isUnmounted) return
            this.runFocusEvent(instance, true)
          }, 200)
        } else {
          omMessage.error(i18n.t('meeting.error.eventNotFound'))
          hideFullScreenLoading()
        }
      }
    }
  }

  runFindInstance = (itemId, startDateObj) => {
    // 날짜가 오늘과 1개월 이상 차이나면 Sync가 필요하므로 동기화 대기.
    if (calendarService.isSyncing()) {
      setTimeout(() => {
        this.runFindInstance(itemId, startDateObj)
      }, 200)
      return
    }

    const instances = calendarService
      .getInstances()
      .filter((instance) => instance.serverId === itemId)

    if (instances.length > 0) {
      let instance = null
      if (startDateObj != null) {
        instance = instances.find(
          (instance) =>
            instance.startDate.getFullYear() === startDateObj.getFullYear() &&
            instance.startDate.getMonth() === startDateObj.getMonth() &&
            instance.startDate.getDate() === startDateObj.getDate(),
        )
      } else {
        instance = instances[0]
      }

      if (instance) {
        this.runFocusEvent(instance)
      } else {
        omMessage.error(i18n.t('meeting.error.eventNotFound'))
        hideFullScreenLoading()
      }
    } else {
      omMessage.error(i18n.t('meeting.error.eventNotFound'))
      hideFullScreenLoading()
    }
  }

  focusEventFromExternal = (itemId, startDateObj) => {
    // 초기화 중에 CurrentDate 변경시 FolderList가 나타나지 않는 등의 문제 발생
    if (calendarService.isSyncing()) {
      setTimeout(() => {
        this.focusEventFromExternal(itemId, startDateObj)
      }, 200)
      return
    }

    const calendarSettings = this.props.settings.calendar
    // settings 미로드 시 calendarSyncTargets가 null일 수 있음 (OFFICEMAIL-WEB-ACCESS-KJ)
    // calendarSyncTargets는 path로, itemId(이벤트 serverId)는 절대 URL로 저장되므로
    // 양쪽을 path로 정규화한 뒤 비교한다. target의 trailing slash는 보존해야
    // '/Default/'와 '/Default2/' 같은 오탐을 막을 수 있다.
    const itemPath = toDavPath(itemId)
    const calendarUrl = (calendarSettings.calendarSyncTargets ?? []).find((target) => {
      const targetPath = toDavPath(target)
      return targetPath !== '' && itemPath.startsWith(targetPath)
    })
    if (calendarUrl == null) {
      const calendar = calendarService
        .getCalendars()
        .find((calendar) => itemId.startsWith(calendar.url))
      if (calendar == null) {
        console.error('calendar not found')
        omMessage.error(i18n.t('meeting.error.eventNotFound'))
        hideFullScreenLoading()
        return
      }
      calendarService.enableSync(calendar.url, true, true)
    }

    calendarService.setCurrentDate(startDateObj)
    this.setState({ focusedDate: startDateObj })

    this.runFindInstance(itemId, startDateObj)
  }

  pollingTimer = null

  resizeObserver = null

  getInitialSearchRange = () => {
    const from = new Date()
    const to = new Date()
    from.setFullYear(from.getFullYear() - 1)
    to.setFullYear(to.getFullYear() + 1)
    to.setHours(23, 59, 59, 999)
    return { from: from, to: to }
  }

  componentDidMount() {
    this.applyViewMode()

    this.folderListener()
    calendarService.addFolderListener(this.folderListener)
    calendarService.addNotificationListener(this.notificationListener)
    calendarService.addInstanceListener(this.instanceListener)

    isUnmounted = false
    calendarService.reloadEvents(true)

    // console.log('set polling timer', Date.now())
    this.pollingTimer = setInterval(
      () => {
        // console.log('fire polling timer', Date.now())
        calendarService.reloadEvents()
      },
      1000 * 60 * 5,
    )

    if (this.dayBoxRef.current) {
      this.setState({
        taskDrawerHeaderHeight: this.dayBoxRef.current.getHeaderHeight(),
      })
    }

    if (this.searchInfo === null) {
      this.searchInfo = {
        searchRange: this.getInitialSearchRange(),
        searchKey: null,
        searchText: null,
      }
    }

    const params = getSearchParams()
    const { item_id, date } = params
    if (date != null) {
      setSearchParams({ item_id: undefined, date: undefined })
      const startDateObj = moment(date, 'YYYYMMDDTHHmmssZ').toDate()
      if (startDateObj != null) {
        if (item_id != null) {
          // 바로 실행시 Calendar FolderList가 나타나지 않는 등의 문제 발생
          showFullScreenLoading()
          setTimeout(() => {
            this.focusEventFromExternal(item_id, startDateObj)
          }, 100)
        } else {
          calendarService.setCurrentDate(startDateObj)
          this.setState({ focusedDate: startDateObj })
        }
      } else {
        console.error('startDate parse error')
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.settings.localSettings.calendar.calendarViewType !== this.state.viewType) {
      this.setState({ viewType: this.props.settings.localSettings.calendar.calendarViewType })
    }
    if (this.props.appsettings.isMobileView !== this.state.isMobileView) {
      this.setState({ isMobileView: this.props.appsettings.isMobileView })
    }
    if (prevProps != null && this.props.viewMode !== prevProps.viewMode) {
      this.applyViewMode()
    }
  }

  componentWillUnmount() {
    calendarService.removeFolderListener(this.folderListener)
    calendarService.removeNotificationListener(this.notificationListener)
    calendarService.removeInstanceListener(this.instanceListener)
    clearInterval(this.pollingTimer)
    isUnmounted = true

    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  applyViewMode = () => {
    if (this.props.viewMode === 'tablet') {
      this.setState({ showSidebar: false })
    } else if (this.props.viewMode === 'desktop') {
      this.setState({ showSidebar: true })
    }
  }

  enterSearchDate = null
  onSearch = (keyword, text) => {
    console.log('Calendar onSearch: keyword: %o, text: %o', keyword, text)
    if (text === null || text === '') {
      this.searchInfo = { ...this.searchInfo, searchKey: keyword, searchText: null }
      this.setState({ searchedEvents: null })
      return
    }
    this.searchInfo = { ...this.searchInfo, searchKey: keyword, searchText: text }
    this.enterSearchDate = calendarService.getCurrentDate()

    const sText = text.toLowerCase()
    let searchInstances = calendarService.getInstances().filter((instance) => {
      return (
        (instance.subject?.toLowerCase().includes(sText) ||
          instance.location?.toLowerCase().includes(sText) ||
          instance.description?.toLowerCase().includes(sText)) &&
        instance.endDate >= this.searchInfo?.searchRange?.from &&
        instance.startDate <= this.searchInfo?.searchRange?.to
      )
    })

    if (keyword !== 'all') {
      searchInstances = searchInstances.filter((instance) => {
        return instance.serverId.startsWith(keyword)
      })
    }

    this.setState({
      searchedEvents: searchInstances,
    })

    function getByteLength(s) {
      const encoder = new TextEncoder()
      const bytes = encoder.encode(s)
      return bytes.length
    }

    if (getByteLength(text) > 3) {
      const searchStartDate = new Date(this.searchInfo?.searchRange?.from)
      const searchEndDate = new Date(this.searchInfo?.searchRange?.to)

      calendarService.searchEventByKeyword(
        text,
        keyword !== 'all' ? [keyword] : null,
        searchStartDate,
        searchEndDate,
        (instances) => {
          console.log('Calendar searchEventByKeyword: %o', instances)
          if (instances.length > 0) {
            const searchedEvents = [...this.state.searchedEvents, ...instances]
            this.setState({ searchedEvents: searchedEvents })
          }
        },
      )
    }
  }

  onSearchEnd = () => {
    console.log('Calendar onSearchEnd')
    this.setState({ searchedEvents: null })
    if (this.enterSearchDate) {
      const enterSearchDate = this.enterSearchDate
      this.enterSearchDate = null
      calendarService.setCurrentDate(enterSearchDate)
      this.setState({ focusedDate: enterSearchDate })
    }
  }

  isSearching = () => {
    return this.state.searchedEvents !== null
  }

  onClickSearchEvent = (event, date) => {
    console.log('Calendar onClockSearchEvent: %o', event)

    if (
      date.getFullYear() !== this.state.focusedDate.getFullYear() ||
      date.getMonth() !== this.state.focusedDate.getMonth() ||
      date.getDate() !== this.state.focusedDate.getDate()
    ) {
      this.setState({ focusedDate: date })
    }
    calendarService.setCurrentDate(date)

    const _eventFocus = () => {
      if (calendarService.isSyncing()) {
        setTimeout(() => {
          _eventFocus()
        }, 100)
        return
      }
      if (this.dayBoxRef.current) {
        setTimeout(() => {
          // 약간의 지연 필요.
          this.dayBoxRef.current.sendExternalClick(event)
        }, 100)
      }
    }

    setTimeout(() => {
      _eventFocus()
    }, 100)
  }

  handleExpandClick = (isExpanded) => {
    this.setState({ isExpanded: isExpanded })
  }

  handleDateChange = (date) => {
    calendarService.setCurrentDate(date)
    this.setState({ focusedDate: date, browseDate: date })
  }

  handlePrevClick = () => {
    let prevDate = null
    const viewType = this.state.viewType
    if (viewType === 'day') {
      prevDate = dateUtils.dateAddingDate(calendarService.getCurrentDate(), -1)
    } else if (viewType === 'week') {
      const dayLength = this.state.isMobileView ? 3 : 7
      prevDate = dateUtils.dateAddingDate(calendarService.getCurrentDate(), -dayLength)
    } else if (viewType === 'month') {
      const prevMonth = dateUtils.getPrevMonth(calendarService.getCurrentDate())
      const today = new Date()
      prevDate = prevMonth
      if (
        prevMonth.getFullYear() === today.getFullYear() &&
        prevMonth.getMonth() === today.getMonth()
      ) {
        prevDate = today
      } else {
        prevDate = dateUtils.getMonthFirstDate(prevMonth)
      }
    }
    calendarService.setCurrentDate(prevDate)
    this.setState({ focusedDate: prevDate, browseDate: prevDate })
  }

  handleNextClick = () => {
    const viewType = this.state.viewType
    let nextDate = null
    if (viewType === 'day') {
      nextDate = dateUtils.dateAddingDate(calendarService.getCurrentDate(), 1)
    } else if (viewType === 'week') {
      const dayLength = this.state.isMobileView ? 3 : 7
      nextDate = dateUtils.dateAddingDate(calendarService.getCurrentDate(), dayLength)
    } else if (viewType === 'month') {
      const nextMonth = dateUtils.getNextMonth(calendarService.getCurrentDate())
      const today = new Date()
      nextDate = nextMonth
      if (
        nextMonth.getFullYear() === today.getFullYear() &&
        nextMonth.getMonth() === today.getMonth()
      ) {
        nextDate = today
      } else {
        nextDate = dateUtils.getMonthFirstDate(nextMonth)
      }
    }
    calendarService.setCurrentDate(nextDate)
    this.setState({ focusedDate: nextDate, browseDate: nextDate })
  }

  handleTodayClick = () => {
    const today = new Date()
    calendarService.setCurrentDate(today)
    this.setState({ focusedDate: today, browseDate: today })

    if (this.calendarNavigationRef.current) {
      this.calendarNavigationRef.current.goToday()
    }
  }

  handleFocusClick = (date) => {
    this.setState({ focusedDate: date })
  }

  handleMonthClick = (date) => {
    calendarService.setCurrentDate(date)
    this.setState({ browseDate: date, focusedDate: date })
  }

  handleNewEventClick = () => {
    let aFocusedDate = this.state.focusedDate
    if (this.state.viewType === 'week') {
      const weekFirstDate = dateUtils.getWeekFirstDate(aFocusedDate)
      const weekLastDate = dateUtils.getWeekLastDate(aFocusedDate)
      const today = new Date()
      if (weekFirstDate > today || today >= weekLastDate) {
        aFocusedDate = weekFirstDate
      } else {
        aFocusedDate = today
      }
    }
    this.setState({
      showEventEditor: true,
      editingEvent: null,
      recurrenceEditMode: null,
      focusedDate: aFocusedDate,
    })
  }

  handleEventDoubleClick = (event, cellElement) => {
    const instance = calendarService.getInstance(event.instanceId)
    if (instance === null) {
      return
    }

    if (instance.isRecurring) {
      this.showRecurrenceScopeDropdown(instance, cellElement, (scope) => {
        this.handleEditEvent(instance.startDate, instance, scope)
      })
    } else {
      this.handleEditEvent(instance.startDate, instance)
    }
  }

  /**
   * 반복 일정에 적용할 범위를 고르는 드롭다운을 셀 위에 띄운다.
   * 시리즈 첫 회차에서는 '이후 모든 일정' 이 '전체 일정' 과 같은 결과가 되므로 노출하지 않는다.
   */
  showRecurrenceScopeDropdown = (instance, cellElement, onScopeSelected) => {
    this.setState({
      dropdownContent: (
        <div className={styles.recurrenceDropdown}>
          {getRecurrenceScopeOptions(instance).map(({ scope, label }) => (
            <div
              key={scope}
              className={styles.dropdownItem}
              onClick={() => {
                this.setState({ showDropdown: false })
                setTimeout(() => {
                  onScopeSelected(scope)
                }, 100)
              }}
            >
              {label}
            </div>
          ))}
        </div>
      ),
      dropdownTarget: cellElement,
      showDropdown: true,
    })
  }

  /**
   * 이벤트 셀 우클릭 컨텍스트 메뉴 항목을 만든다.
   * 할일과 '더보기' 셀에는 메뉴를 띄우지 않고, 읽기 전용 캘린더의 이벤트는 복제만 노출한다.
   */
  getEventContextMenuItems = (event) => {
    if (event == null || event.isTodo === true || !event.instanceId) return null

    const instance = calendarService.getInstance(event.instanceId)
    if (instance == null) return null

    const items: OmMenuItem[] = [
      {
        key: 'duplicate',
        label: i18n.t('signature.menu.duplicate'),
        onClick: () => {
          this.handleEditEvent(instance.startDate, instance, 'this', null, true)
        },
      },
    ]

    if (!isEventEditable(instance)) {
      return items
    }

    const editLabel = i18n.t('common.button.edit')
    const deleteLabel = <span style={{ color: 'red' }}>{i18n.t('common.button.delete')}</span>

    // 반복 일정은 적용 범위를 서브메뉴로 고르게 하고, 단일 일정은 바로 실행한다.
    if (instance.isRecurring) {
      const scopeOptions = getRecurrenceScopeOptions(instance)

      items.push(
        {
          key: 'edit',
          label: editLabel,
          children: scopeOptions.map(({ scope, label }) => ({
            key: `edit-${scope}`,
            label,
            onClick: () => {
              this.handleEditEvent(instance.startDate, instance, scope)
            },
          })),
        },
        { type: 'divider' as const },
        {
          key: 'delete',
          label: deleteLabel,
          children: scopeOptions.map(({ scope, label }) => ({
            key: `delete-${scope}`,
            label,
            onClick: () => {
              confirmAndDeleteEvent(instance, scope)
            },
          })),
        },
      )

      return items
    }

    items.push(
      {
        key: 'edit',
        label: editLabel,
        onClick: () => {
          this.handleEditEvent(instance.startDate, instance)
        },
      },
      { type: 'divider' as const },
      {
        key: 'delete',
        label: deleteLabel,
        onClick: () => {
          confirmAndDeleteEvent(instance)
        },
      },
    )

    return items
  }

  handleEventEditorClose = () => {
    if (this.state.onEditComplete) {
      this.state.onEditComplete()
    }
    this.setState({
      showEventEditor: false,
      editingEvent: null,
      targetDates: null,
      duplicateEvent: false,
      onEditComplete: null,
    })
  }

  hideSidebar = () => {
    this.setState({
      showSidebar: false,
    })
  }

  handleMenuClick = () => {
    this.setState((prevState) => ({
      ...prevState,
      showSidebar: !prevState.showSidebar,
    }))
  }

  handleViewChange = (viewType) => {
    this.setState({
      viewType,
    })
    this.searchRef?.clearSearch()
    calendarService.setViewType(viewType)
  }

  handleFolderEditorClose = () => {
    this.setState({
      showFolderEditor: false,
      editingFolder: null,
    })
  }

  handleFolderSave = (folderData) => {
    if (this.state.editingFolder) {
      calendarService.updateCalendar(
        this.state.editingFolder.url,
        folderData.displayName,
        folderData.color,
      )
    } else {
      calendarService.createCalendar(folderData.displayName, folderData.color)
    }
    this.handleFolderEditorClose()
  }

  handleFolderRemove = (folderId) => {
    confirmDelete({
      title: i18n.t('calendar.edit.deleteCalendar'),
      content: i18n.t('calendar.edit.deleteCalendarConfirm').replace(/<br\/>/g, '\n'),
      okText: i18n.t('common.button.ok'),
      cancelText: i18n.t('common.button.cancel'),
      onOk: () => {
        console.log('OK')
        calendarService.deleteCalendar(folderId)
      },
      onCancel: () => {
        console.log('Cancel')
      },
    })
  }

  handleSubscriptionEdit = (folderId: string) => {
    const subscriptions = calendarService.getSubscriptions()
    const calendarUrlPrefix = 'subscription://'
    const subscriptionId = folderId.startsWith(calendarUrlPrefix)
      ? folderId.replace(calendarUrlPrefix, '').replace(/\/$/, '')
      : folderId
    const subscription = subscriptions.find((s) => s.id === subscriptionId)
    if (subscription) {
      this.setState({
        showSubscriptionEditor: true,
        editingSubscription: subscription,
      })
    }
  }

  handleSubscriptionEditorClose = () => {
    this.setState({
      showSubscriptionEditor: false,
      editingSubscription: null,
    })
  }

  handleSubscriptionSave = async (data: SubscriptionEditorData) => {
    const { editingSubscription } = this.state
    if (editingSubscription) {
      calendarService.updateSubscription(editingSubscription.id, {
        displayName: data.displayName,
        color: data.color,
        refreshInterval: data.refreshInterval,
      })
      this.handleSubscriptionEditorClose()
    } else {
      this.setState({ subscriptionSaving: true })
      const success = await calendarService.subscribe(data.url, data.displayName || '', data.color)
      this.setState({ subscriptionSaving: false })
      if (success) {
        this.handleSubscriptionEditorClose()
      } else {
        omNotification.error({
          message: i18n.t('calendar.subscription.fetchFailed'),
        })
      }
    }
  }

  handleUnsubscribe = (folderId: string) => {
    const calendarUrlPrefix = 'subscription://'
    const subscriptionId = folderId.startsWith(calendarUrlPrefix)
      ? folderId.replace(calendarUrlPrefix, '').replace(/\/$/, '')
      : folderId

    const subscriptions = calendarService.getSubscriptions()
    const subscription = subscriptions.find((s) => s.id === subscriptionId)
    const displayName = subscription?.displayName || ''

    confirmDelete({
      title: i18n.t('calendar.subscription.unsubscribeTitle', { name: displayName }),
      content: i18n.t('calendar.subscription.unsubscribeConfirm'),
      okText: i18n.t('calendar.subscription.unsubscribe'),
      okButtonProps: {
        style: { backgroundColor: '#FD4C45', borderColor: '#FD4C45' },
      },
      cancelText: i18n.t('common.button.cancel'),
      onOk: () => {
        calendarService.unsubscribe(subscriptionId)
      },
      onCancel: () => {},
    })
  }

  handleEventDetailClose = () => {
    this.setState({
      selectedEvent: null,
      eventDetailPosition: null,
    })
  }

  kArrowOffset = 8
  showEventDetail = (event, cellElement) => {
    if (!this.calendarRef.current || cellElement == null || event == null) return
    if (event.isTodo) {
      modalTodoDetails(event.todo)
      return
    }

    const containerElement = this.calendarRef.current

    const containerRect = containerElement.getBoundingClientRect()
    const rect = cellElement.getBoundingClientRect()
    const width = 400

    // viewport 기준 위치를 container 기준의 상대 위치로 변환
    const relativeTop = rect.top - containerRect.top + rect.height / 2
    const relativeLeft = rect.left - containerRect.left

    // 기본적으로 오른쪽에 표시
    let placement = 'right'
    let arrowPosition = 'left'

    // 오른쪽 공간이 부족하면 왼쪽에 표시
    if (rect.right + width + 10 > window.innerWidth - 20) {
      placement = 'left'
      arrowPosition = 'right'
    }

    this.setState({
      eventDetailPosition: {
        arrowPosition,
        eventRect: {
          ...rect,
          top: relativeTop,
          left:
            arrowPosition === 'right'
              ? relativeLeft
              : relativeLeft + rect.width - this.kArrowOffset * 2,
        },
        placement,
      },
      selectedEvent: event,
    })
  }

  onEventDetailDidRender = (eventDetailElement) => {
    if (eventDetailElement && this.state.eventDetailPosition) {
      const height = eventDetailElement.clientHeight
      const windowRect = this.calendarRef.current.getBoundingClientRect()
      const oldTop = this.state.eventDetailPosition.top
      let newTop = oldTop

      // Check if the event detail overflows the bottom of the window
      if (newTop + height > windowRect.bottom - 20) {
        newTop = windowRect.bottom - 20 - height
      }

      // Adjust the position if it overflows the top
      if (newTop < 20) {
        newTop = 20
      }

      if (newTop !== oldTop) {
        const arrowOffset = oldTop - newTop
        this.setState((prev) => ({
          eventDetailPosition: {
            ...prev.eventDetailPosition,
            top: newTop,
            arrowOffset: arrowOffset,
          },
        }))
      }
    }
  }

  handleSearchFocusedDate = (date) => {
    console.log('handleSearchFocusedDate: %o', date)
    this.setState({ focusedDate: date })
    calendarService.setCurrentDate(date)
  }

  handleEditEvent = (
    date,
    event = null,
    recurrenceEditMode = null,
    targetDates = null,
    duplicateEvent = false,
    forAllday = false,
    onEditComplete = null,
  ) => {
    if (event && event.instanceId) {
      const instanceId = event.instanceId
      event = calendarService.getInstances().find((i) => i.id === instanceId)
    }
    this.setState({
      showEventEditor: true,
      focusedDate: date,
      editingEvent: event,
      recurrenceEditMode: recurrenceEditMode,
      targetDates: targetDates,
      duplicateEvent: duplicateEvent,
      forAllday: forAllday,
      onEditComplete: onEditComplete,
    })
  }

  getDayBox = () => {
    const { focusedDate } = this.state
    return (
      <DayBox
        date={focusedDate}
        onEditEvent={this.handleEditEvent}
        onEventClick={this.showEventDetail}
        onEventDoubleClick={this.handleEventDoubleClick}
        getEventContextMenuItems={this.getEventContextMenuItems}
        ref={this.dayBoxRef}
      />
    )
  }

  getWeekBox = () => {
    const { focusedDate } = this.state
    console.log('focusedDate', focusedDate)
    return (
      <WeekBox
        date={focusedDate}
        onEditEvent={this.handleEditEvent}
        onEventClick={this.showEventDetail}
        onEventDoubleClick={this.handleEventDoubleClick}
        getEventContextMenuItems={this.getEventContextMenuItems}
      />
    )
  }

  handleInvitationListClose = () => {
    this.setState({ showNotification: false })
  }

  handleShareClick = (folderId) => {
    const folder = this.state.folders.find((f) => f.url === folderId)
    if (!folder) return
    this.setState({
      showShareInfoModal: true,
      shareInfoFolder: folder,
    })
  }

  handleFolderEdit = (folderId) => {
    const folder = this.state.folders.find((f) => f.url === folderId)
    if (folder?.folderType === 'subscription') {
      this.handleSubscriptionEdit(folderId)
      return
    }
    this.setState({
      showFolderEditor: true,
      editingFolder: { ...folder, color: folder.calendarColor._cdata },
    })
  }

  handleCheckClick = (isChecked, folderId) => {
    calendarService.enableSync(folderId, isChecked)
    this.folderListener()
  }

  handleShareInfoClose = () => {
    this.setState({ showShareInfoModal: false, shareInfoFolder: null })
  }

  getModalJSX = () => {
    const {
      focusedDate,
      showEventEditor,
      editingEvent,
      recurrenceEditMode,
      duplicateEvent,
      showFolderEditor,
      editingFolder,
      targetDates,
      forAllday,
    } = this.state
    return (
      <React.Fragment>
        <OmDialog
          wrapClassName={classNames('eventEditorModal')}
          className={classNames('mobile-fullpage')}
          open={showEventEditor}
          width={640}
          destroyOnHidden
          closable={false}
          contentStyle={{ padding: 0, overflow: 'hidden', maxHeight: '90vh' }}
        >
          <EventEditor
            instance={editingEvent}
            date={focusedDate}
            title={editingEvent?.title || ''}
            onClose={this.handleEventEditorClose}
            targetDates={targetDates}
            recurrenceEditMode={recurrenceEditMode}
            duplicateEvent={duplicateEvent}
            forAllday={forAllday}
          />
        </OmDialog>

        <OmDialog
          open={showFolderEditor}
          onClose={this.handleFolderEditorClose}
          width={480}
          destroyOnHidden
          closable={false}
          contentStyle={{ padding: 0, overflow: 'hidden', maxHeight: '90vh' }}
        >
          <FolderEditor
            folder={editingFolder}
            onSave={this.handleFolderSave}
            onClose={this.handleFolderEditorClose}
          />
        </OmDialog>

        <OmDialog
          open={this.state.showSubscriptionEditor}
          onClose={this.handleSubscriptionEditorClose}
          width={480}
          destroyOnHidden
          closable={false}
          contentStyle={{ padding: 0, overflow: 'hidden', maxHeight: '90vh' }}
        >
          <SubscriptionEditor
            subscription={this.state.editingSubscription}
            onSave={this.handleSubscriptionSave}
            onClose={this.handleSubscriptionEditorClose}
            loading={this.state.subscriptionSaving}
          />
        </OmDialog>

        <OmDialog
          open={this.state.showNotification}
          onClose={this.handleInvitationListClose}
          width={480}
          destroyOnHidden
          closable={false}
          contentStyle={{ padding: 0, overflow: 'hidden', maxHeight: '90vh' }}
        >
          <InvitationList onClose={this.handleInvitationListClose} />
        </OmDialog>

        <OmDialog
          open={this.state.showShareInfoModal}
          onClose={this.handleShareInfoClose}
          width={480}
          destroyOnHidden
          closable={false}
          contentStyle={{ padding: 0, overflow: 'hidden', maxHeight: '90vh' }}
        >
          <FolderShareInfo
            onClose={this.handleShareInfoClose}
            folder={this.state.shareInfoFolder}
          />
        </OmDialog>
      </React.Fragment>
    )
  }

  getEventDetailContent = () => {
    const { selectedEvent } = this.state
    if (!selectedEvent) return null

    // instance 가 동기화/삭제로 사라지면 EventDetail 을 undefined 로 재렌더하지 않고 언마운트시킨다.
    const instance = calendarService
      .getInstances()
      .find((instance) => instance.id === selectedEvent.instanceId)
    if (!instance) return null

    return (
      <EventDetail
        event={instance as any}
        onEdit={(recurrenceEditMode) => {
          this.handleEventDetailClose()
          setTimeout(() => {
            this.handleEditEvent(selectedEvent.date, selectedEvent, recurrenceEditMode)
          }, 0)
        }}
        onDuplicate={(_event) => {
          this.handleEventDetailClose()
          setTimeout(() => {
            this.handleEditEvent(selectedEvent.date, selectedEvent, 'this', null, true)
          }, 0)
        }}
        onClose={this.handleEventDetailClose}
        onDidRender={this.onEventDetailDidRender}
      />
    )
  }

  getFolderList = () => {
    const { folders } = this.state
    return (
      <React.Fragment>
        <FolderList
          folders={folders}
          onCheckClick={this.handleCheckClick}
          onFolderEdit={this.handleFolderEdit}
          onShareClick={this.handleShareClick}
          onDeleteClick={this.handleFolderRemove}
          onUnsubscribeClick={this.handleUnsubscribe}
        />
        <TaskFolderList {...({} as any)} />
      </React.Fragment>
    )
  }

  getSearchMenuItems = () => {
    const items = [{ key: 'all', label: i18n.t('calendar.search.allCalendars') }]

    const subItems = []
    const calendars = calendarService.getCalendars()
    calendars?.forEach((calendar) => {
      if (calendar.isSync) {
        subItems.push({ key: calendar.url, label: calendar.displayName })
      }
    })
    if (subItems.length > 0) {
      items.push({
        type: 'divider',
      } as any)
    }
    items.push(...subItems)
    return items
  }

  getSearchSuffix = () => {
    const onSearchRangeChange = (key, date) => {
      if (key === 'to') {
        date.setHours(23, 59, 59, 999)
      }
      this.searchInfo = {
        ...this.searchInfo,
        searchRange: { ...this.searchInfo.searchRange, [key]: date },
      }
      this.onSearch(this.searchInfo.searchKey, this.searchInfo.searchText)
    }

    const getSearchRangeItem = ({ key, label }, date) => {
      return (
        <div className={styles.searchRangeItem}>
          <div className={styles.searchRangeItemLabelContainer}>
            <div className={styles.searchRangeItemLabel}>{label}</div>
          </div>
          <div className={styles.searchRangeItemDate}>
            <OmPopover
              placement="bottomLeft"
              arrow={false}
              bodyStyle={{ padding: 0 }}
              open={!!this.state[`${key}OpenPicker`]}
              onOpenChange={(open) => {
                this.setState({ [`${key}OpenPicker`]: open })
              }}
              content={
                <CalendarDatePicker
                  pickerType={DatePickerType.DATE}
                  value={date}
                  onChange={(date) => onSearchRangeChange(key, date)}
                  onClose={() => {
                    this.setState({ [`${key}OpenPicker`]: false })
                  }}
                />
              }
            >
              <div className={styles.dateDisplay}>
                <span className={styles.dateValue}>{dateUtils.localizedDateString(date)}</span>
                <img src={calendarIcon} alt="Calendar" className={styles.chevronIcon} />
              </div>
            </OmPopover>
          </div>
        </div>
      )
    }

    return (
      <OmPopover
        placement="bottomRight"
        arrow={false}
        bodyStyle={{ padding: 0 }}
        open={!!this.state.openSearchFilter}
        onOpenChange={(open) => {
          this.setState({ openSearchFilter: open })
        }}
        content={
          <div className={styles.searchRangeContainerWrapper}>
            <div className={styles.searchRangeContainer}>
              {getSearchRangeItem(
                { key: 'from', label: i18n.t('calendar.search.from') },
                this.searchInfo?.searchRange?.from || new Date(),
              )}
              {getSearchRangeItem(
                { key: 'to', label: i18n.t('calendar.search.to') },
                this.searchInfo?.searchRange?.to || new Date(),
              )}
            </div>
            <div className={styles.divider} />
            <div className={styles.clearFilterContainer}>
              <div className={styles.clearFilter} onClick={this.handleClearSearchFilter}>
                {i18n.t('calendar.search.clearFilter')}
              </div>
            </div>
          </div>
        }
      >
        <img src={optionSVG} alt="option" />
      </OmPopover>
    )
  }

  handleClearSearchFilter = () => {
    this.searchInfo = { ...this.searchInfo, searchRange: this.getInitialSearchRange() }
    this.onSearch(this.searchInfo.searchKey, this.searchInfo.searchText)
    this.searchRef?.forceUpdate()
  }

  render() {
    const {
      folders,
      isExpanded,
      focusedDate,
      browseDate,
      showSidebar,
      selectedEvent,
      eventDetailPosition,
      searchedEvents,
      isMobileView,
      notiCount,
    } = this.state
    const clsProp = {}

    const user: any = calendarService.getUserInfo()
    const { accountName } = this.props.settings.account

    if (isMobileView) {
      return (
        <div ref={this.calendarRef} className={styles.mobileWrapper} data-testid="calendar-page">
          <CalendarMobile
            presentData={
              {
                folders,
                accountName,
                user,
                isExpanded,
                notiCount,
                browseDate,
                focusedDate,
              } as any
            }
            getFolderList={this.getFolderList}
            onEditEvent={this.handleEditEvent}
            onEventClick={this.showEventDetail}
            onEventDoubleClick={this.handleEventDoubleClick}
            onFolderNotiClick={() => {
              this.setState({
                showNotification: true,
              })
            }}
            onFolderExpandClick={() => this.handleExpandClick(isExpanded)}
            onNewFolder={() => {
              this.setState({
                showFolderEditor: true,
                editingFolder: null,
              })
            }}
            onDateChange={this.handleDateChange}
            onNext={this.handleNextClick}
            onPrev={this.handlePrevClick}
          />
          {this.getModalJSX()}
          {selectedEvent && eventDetailPosition && (
            <OmDialog
              className={classNames('mobile-fullpage')}
              open={true}
              onClose={() => this.setState({ selectedEvent: null })}
              width={640}
              destroyOnHidden
              closable={false}
              contentStyle={{ padding: 0, overflow: 'hidden', maxHeight: '90vh' }}
            >
              {this.getEventDetailContent()}
            </OmDialog>
          )}
        </div>
      )
    }

    return (
      <div
        className={classNames(styles.main, clsProp)}
        ref={this.calendarRef}
        data-testid="calendar-page"
        data-view-type={this.state.viewType}
      >
        <OmRow
          className={classNames('mainTop')}
          style={{ width: '100%' }}
          data-testid="calendar-top"
        >
          <OmCol span={24}>
            <CalendarToolbar
              viewType={this.state.viewType}
              currentDate={focusedDate}
              onPrevClick={this.handlePrevClick}
              onNextClick={this.handleNextClick}
              onTodayClick={this.handleTodayClick}
              onMonthClick={this.handleMonthClick}
              onNewEventClick={this.handleNewEventClick}
              onMenuClick={this.handleMenuClick}
              onViewChange={this.handleViewChange}
              isSearching={this.isSearching()}
            />
          </OmCol>
        </OmRow>
        <OmRow
          className={classNames('mainRow', { showSidebar })}
          data-testid="calendar-layout"
          data-sidebar-visible={showSidebar ? 'true' : 'false'}
        >
          <OmCol data-testid="calendar-sidebar-column">
            <CalendarDatePicker
              pickerType={
                this.state.viewType === 'week' ? DatePickerType.WEEK : DatePickerType.DATE
              }
              value={focusedDate}
              useTodayMenu={false}
              disableExpand={false}
              navigationContainerType={true}
              onChange={this.handleDateChange}
            />
            {/* <DateNavigater
              focusedDate={focusedDate}
              onDateChange={this.handleDateChange}
              viewType={this.state.viewType}
              ref={this.calendarNavigationRef}
            /> */}
            <div className={styles.separator} />
            <div className={styles.accountInfoContainer}>
              <AccountInfoView
                name={accountName}
                email={user.email}
                expanded={isExpanded}
                count={this.state.notiCount}
                onExpandClick={this.handleExpandClick}
                onAddClick={() => {
                  this.setState({
                    showFolderEditor: true,
                    editingFolder: null,
                  })
                }}
                onAddSubscriptionClick={() => {
                  this.setState({
                    showSubscriptionEditor: true,
                    editingSubscription: null,
                  })
                }}
                onNotiClick={() => {
                  this.setState({
                    showNotification: true,
                  })
                }}
              />
              {isExpanded && this.getFolderList()}
            </div>
          </OmCol>
          {this.isSearching() ? (
            <React.Fragment>
              <OmCol style={{ flex: 1 }} data-testid="calendar-agenda-column">
                <AgendaBox
                  events={searchedEvents}
                  onFocusedDate={this.handleSearchFocusedDate}
                  onEventClick={this.onClickSearchEvent}
                />
              </OmCol>
              <OmCol style={{ flex: 2 }} data-testid="calendar-main-column">
                {this.getDayBox()}
              </OmCol>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <OmCol style={{ flex: 1 }} data-testid="calendar-main-column">
                {this.state.viewType === 'day' && this.getDayBox()}
                {this.state.viewType === 'day' && !this.state.taskDrawerOpen && (
                  <div
                    className={styles.drawerButton}
                    onClick={() => {
                      this.setState({ taskDrawerOpen: true })
                      settingsObject.setValue('localSettings', {
                        ...this.props.settings.localSettings,
                        calendar: {
                          ...this.props.settings.localSettings.calendar,
                          taskDrawerOpen: true,
                        },
                      })
                    }}
                  >
                    <img src={openDrawer} alt="openDrawer" />
                  </div>
                )}
                {this.state.viewType === 'week' && this.getWeekBox()}
                {this.state.viewType === 'month' && (
                  <MonthBox
                    browseDate={browseDate}
                    focusedDate={focusedDate}
                    onFocusClick={this.handleFocusClick}
                    onEditEvent={this.handleEditEvent}
                    onEventClick={this.showEventDetail}
                    onEventDoubleClick={this.handleEventDoubleClick}
                    getEventContextMenuItems={this.getEventContextMenuItems}
                  />
                )}
              </OmCol>
              {this.state.viewType === 'day' && this.state.taskDrawerOpen && (
                <OmCol
                  className={styles.taskDrawer}
                  style={{ flex: 1 }}
                  data-testid="calendar-task-drawer"
                >
                  <TaskDrawer
                    headerHeight={this.state.taskDrawerHeaderHeight}
                    focusDate={focusedDate}
                    onClose={() => {
                      this.setState({ taskDrawerOpen: false })
                      settingsObject.setValue('localSettings', {
                        ...this.props.settings.localSettings,
                        calendar: {
                          ...this.props.settings.localSettings.calendar,
                          taskDrawerOpen: false,
                        },
                      })
                    }}
                  />
                </OmCol>
              )}
            </React.Fragment>
          )}
          <OmCol
            className={classNames('sidebarMask')}
            onClick={this.hideSidebar}
            data-testid="calendar-sidebar-mask"
          />
        </OmRow>

        <SearchPortal
          innerRef={(ref) => {
            this.searchRef = ref
          }}
          getMenu={this.getSearchMenuItems}
          defaultSearchTypeKey="all"
          reloadMenuWhenFocus={true}
          onSearch={this.onSearch}
          onSearchEnd={this.onSearchEnd}
          searchDelay={2000}
          suffix={this.getSearchSuffix()}
        />

        {this.getModalJSX()}

        {selectedEvent && eventDetailPosition && (
          <React.Fragment>
            <div className={styles.overlay} onClick={this.handleEventDetailClose} />
            <OmPopover
              content={this.getEventDetailContent()}
              trigger="click"
              open={true}
              placement={eventDetailPosition.placement}
              rootStyle={{ width: '400px' }}
              bodyStyle={{ padding: 0 }}
              onOpenChange={(open: boolean) => {
                if (!open) {
                  this.handleEventDetailClose()
                }
              }}
              getPopupContainer={() => this.calendarRef.current}
            >
              <div
                style={{
                  position: 'absolute',
                  top: eventDetailPosition.top || eventDetailPosition.eventRect.top,
                  left: eventDetailPosition.eventRect.left + this.kArrowOffset,
                  width: 1,
                  height: 1,
                }}
              />
            </OmPopover>
          </React.Fragment>
        )}

        {this.state.showDropdown && this.state.dropdownTarget && (
          <OmPopover
            content={this.state.dropdownContent}
            trigger="click"
            open={true}
            placement="bottomLeft"
            arrow={false}
            rootStyle={{ padding: 0 }}
            bodyStyle={{ padding: 0 }}
            onOpenChange={(open: boolean) => {
              if (!open) {
                this.setState({ showDropdown: false })
              }
            }}
            getPopupContainer={() => this.calendarRef.current}
          >
            <div
              style={{
                position: 'fixed',
                top: this.state.dropdownTarget.getBoundingClientRect().top + 24,
                left: this.state.dropdownTarget.getBoundingClientRect().left,
                width: 1,
                height: 1,
              }}
            />
          </OmPopover>
        )}

        <img
          id="dragImage"
          src={'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'}
          alt="dragImage"
          style={{ position: 'absolute', bottom: 0, left: 0 }}
          width={1}
          height={1}
        />
      </div>
    )
  }
}

const Calendar = withRouter(connect(mapStateToProps)(CalendarDef))

export default Calendar

export { modalEventEditor } from './modalHelpers'
